var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"wrapper"},[_vm._m(0),(_vm.msg)?_c('div',{staticClass:"text",domProps:{"textContent":_vm._s(_vm.msg)}}):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }